import React from "react";
import Breadcrumb from "../../../core/common/Breadcrumb/breadcrumb";
import ProfileCard from "../common/profileCard";
import StudentSidebar from "../common/studentSidebar";
import LiveClassDashboard from "../common/liveClassDashboard";
import { useTranslation } from "react-i18next";
import { useHandleCourses } from "../../../core/hooks/useHandleCourses";
import { useAuth } from "../../../core/hooks/useAuth";

const StudentLiveClasses = () => {
  const { t } = useTranslation();
  const { moodleUser } = useAuth();
  const { enrolledCourses, isEnrolledCoursesLoading } = useHandleCourses(
    moodleUser?.id
  );
  return (
    <>
      <div className="content">
        <div className="container">
          {/* Profile Box */}
          <ProfileCard />
          <div className="row">
            {/* Sidebar */}
            <StudentSidebar />
            {/* Main Content */}
            <div className="col-lg-9">
              <Breadcrumb title={t("liveClasses.title")} />
              {/* Live Class Dashboard */}
              <LiveClassDashboard maxItems={5} enrolledCourses={enrolledCourses}/>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StudentLiveClasses;
